import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDlYzU7SvuP8BuW7EQxEMrva5ypQlfxGwU",
  authDomain: "parent-portal-tpc.firebaseapp.com",
  projectId: "parent-portal-tpc",
  storageBucket: "parent-portal-tpc.firebasestorage.app",
  messagingSenderId: "732957651131",
  appId: "1:732957651131:web:41dd80e42641138980799e"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

console.log("Firebase initialized:", app.name);